import { Header } from '../components/Header';
import React, { useEffect } from 'react';

export const Faq = () => {
    useEffect(() => {
       window.scrollTo(0, 0);
   }, []);

    return(
        <>
            <Header/>
            <div className="container my-5 mt-5 pt-4">
                <div className="d-flex justify-content-between align-items-center" id="view_all">
                    <h1  id="have_any">Have any <span style={{color:'#00675B'}}>questions?</span></h1>
                </div>
                <div className="accordion" id="faqAccordion">
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            1.	What is the "Collaborate with Government"?
                            </button>
                        </h2>
                        <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">
                                The "Collaborate with Government" initiative, hosted on OpenForge, allows students, developers, and coding enthusiasts to contribute to real-world government projects. 
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTwo">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            2.	What is OpenForge, and how can I access it?
                            </button>
                        </h2>
                        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">
                                OpenForge is the platform where government-related open-source projects are hosted for collaboration. Contributors can access the platform and participate in projects through the link:  <a href="https://openforge.gov.in/">https://openforge.gov.in/</a>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingThree">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            3.	Who is eligible to contribute to "Collaborate with Government"?
                            </button>
                        </h2>
                        <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">
                                Any student, developer, or coding enthusiast with relevant skills can contribute. There are no strict educational or professional requirements. You just need a passion for coding and a desire to work on public projects. Each task will have its own technical skill requirements.
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingFour">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                            4.	What kind of projects can I contribute to?
                            </button>
                        </h2>
                        <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">
                                You can contribute to various government projects related to digital services, public infrastructure, e-governance applications, and other technology-driven initiatives. These projects can involve development, bug fixing, testing, documentation, and design.
                            </div>
                        </div>
                    </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFive">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                        5.	Do I need to be a professional developer to contribute?
                        </button>
                    </h2>
                    <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            No, contributions are open to all levels of experience, from beginners to professionals. 
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingSix">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                        6.	What types of tasks can I contribute to?
                        </button>
                    </h2>
                    <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            You can contribute to a variety of tasks, including:
                            <ol type="i">
                                <li>Code improvement suggestions</li>
                                <li>Test data preparation</li>
                                <li>Test Case preparation</li>
                                <li>Manual Testing</li>
                                <li>Automated testing - e.g. Selenium scripts</li>
                                <li>System Design Architecture suggestions</li>
                                <li>UX audit report submission</li>
                                <li>HTML web page design</li>
                                <li>Website development</li>
                                <li>Security Bug Testing</li>
                                <li>Performance Testing</li>
                                <li>New Feature development</li>
                                <li>Library/ Plugin Development</li>
                            </ol>
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingSeven">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                        7.	Can I contribute to multiple tasks at once?
                        </button>
                    </h2>
                    <div id="collapseSeven" className="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            Yes, you can contribute to multiple tasks. Just ensure that you create a new branch for each task, so the changes remain separate and do not interfere with one another.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingEight">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                        8.	Can I contribute in areas other than coding?
                        </button>
                    </h2>
                    <div id="collapseEight" className="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            Yes! Contributions are not limited to coding. You can help improve documentation, suggest feature enhancements, report bugs, test applications, or even contribute to design and user experience improvements.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingNine">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                        9.	How can task creators set up a task?
                        </button>
                    </h2>
                    <div id="collapseNine" className="accordion-collapse collapse" aria-labelledby="headingNine" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            Task creators should create a task in the "Collaborate with Government" tracker within the "OpenForge Community" project. The repository should be made accessible to all registered users on OpenForge.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTen">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                        10.	What are the steps for contributors to contribute code?
                        </button>
                    </h2>
                    <div id="collapseTen" className="accordion-collapse collapse" aria-labelledby="headingTen" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            <ol type="i">
                                <li>Clone the repository using git clone (repo URL).</li>
                                <li>Create a new branch using git checkout -b feature/your-branch-name.</li>
                                <li>Make and test the changes.</li>
                                <li>Commit the changes using git commit -m "Description of changes made".</li>
                                <li>Push the changes to the forked repository using git push origin feature/your-branch-name.</li>
                                <li>Submit a Pull Request (PR) on OpenForge.</li>
                            </ol>
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingEleven">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEleven" aria-expanded="false" aria-controls="collapseEleven">
                        11.	How do contributors submit their code for review?
                        </button>
                    </h2>
                    <div id="collapseEleven" className="accordion-collapse collapse" aria-labelledby="headingEleven" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            After pushing changes to the forked repository, contributors can create a Pull Request (PR) by navigating to the task repository on OpenForge and clicking "Compare & pull request."
                        </div>
                    </div>
                </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTwelve">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwelve" aria-expanded="false" aria-controls="collapseTwelve">
                            12.	What information should I include in the Pull Request (PR)?
                            </button>
                        </h2>
                        <div id="collapseTwelve" className="accordion-collapse collapse" aria-labelledby="headingTwelve" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">
                                Your PR should include:
                                <ol type="i">
                                    <li>A clear title describing the changes.</li>
                                    <li></li>
                                    <li>A detailed description of the changes you made.</li>
                                    <li>Reference to any related issues or bugs that the PR addresses.
                                    </li>
                                </ol>
                                This helps maintainers understand your contributions better.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThirteen">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirteen" aria-expanded="false" aria-controls="collapseThirteen">
                        13. How do contributors handle feedback on their PR?
                        </button>
                    </h2>
                    <div id="collapseThirteen" className="accordion-collapse collapse" aria-labelledby="headingThirteen" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            Contributors should monitor their PR for feedback from reviewers. If changes are required, they can make additional commits to the same branch and push the updates using git push origin feature/your-branch-name.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFourteen">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFourteen" aria-expanded="false" aria-controls="collapseFourteen">
                        14. What happens after the PR is submitted?
                        </button>
                    </h2>
                    <div id="collapseFourteen" className="accordion-collapse collapse" aria-labelledby="headingFourteen" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            Once the PR is approved, the repository maintainers will merge it into the main branch. If it is not approved, contributors should address the feedback or close the PR if it's no longer relevant.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFifteen">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFifteen" aria-expanded="false" aria-controls="collapseFifteen">
                        15. 	What coding standards must be followed?
                        </button>
                    </h2>
                    <div id="collapseFifteen" className="accordion-collapse collapse" aria-labelledby="headingFifteen" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            All contributions should follow coding best practices, the specific project guidelines, and OpenForge community standards.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingSixteen">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSixteen" aria-expanded="false" aria-controls="collapseSixteen">
                        16.	Why should I create a new branch for my changes?
                        </button>
                    </h2>
                    <div id="collapseSixteen" className="accordion-collapse collapse" aria-labelledby="headingSixteen" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            Creating a new branch ensures that the main branch remains clean and stable. It allows you to work on your changes independently and avoids conflicts with the main codebase.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingSeventeen">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventeen" aria-expanded="false" aria-controls="collapseSeventeen">
                        17.	What should I do before committing my changes?
                        </button>
                    </h2>
                    <div id="collapseSeventeen" className="accordion-collapse collapse" aria-labelledby="headingSeventeen" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            Before committing, make sure that:
                            <ol type="i">
                                <li>Your code adheres to the repository’s contribution guidelines.</li>
                                <li>You have tested your changes to ensure they work correctly.</li>
                                <li>You can run tests or builds as required by the project to validate your code.</li>
                            </ol>
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingEighteen">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEighteen" aria-expanded="false" aria-controls="collapseEighteen">
                        18.	How do I monitor feedback on my Pull Request (PR)?
                        </button>
                    </h2>
                    <div id="collapseEighteen" className="accordion-collapse collapse" aria-labelledby="headingEighteen" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            Once the PR is submitted, you can monitor it on the OpenForge platform. Check regularly for comments or requested changes by the reviewers. You can make updates by committing changes to the same branch and pushing them again.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingNineteen">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNineteen" aria-expanded="false" aria-controls="collapseNineteen">
                        19.	What should I do if my Pull Request (PR) requires changes?
                        </button>
                    </h2>
                    <div id="collapseNineteen" className="accordion-collapse collapse" aria-labelledby="headingNineteen" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            If a reviewer suggests changes, you can modify your code, commit the changes to the same branch, and push the updates. The PR will automatically update with your latest commits.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwenty">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwenty" aria-expanded="false" aria-controls="collapseTwenty">
                        20. What happens if my Pull Request (PR) is not approved?
                        </button>
                    </h2>
                    <div id="collapseTwenty" className="accordion-collapse collapse" aria-labelledby="headingTwenty" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            If your PR is not approved, carefully review the feedback provided by the maintainers. You can:
                            <ol type="i">
                                <li>Address the requested changes and resubmit or</li>
                                <li>Close the PR if it is no longer needed or relevant.</li>
                            </ol>
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwentyone">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentyone" aria-expanded="false" aria-controls="collapseTwentyone">
                        21.	How do I ensure my code follows best practices?
                        </button>
                    </h2>
                    <div id="collapseTwentyone" className="accordion-collapse collapse" aria-labelledby="headingTwentyone" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            Follow these steps to ensure adherence to best coding practices:
                            <ol type="i">
                                <li>Read the repository’s contribution guidelines thoroughly</li>
                                <li>Write clean, maintainable code</li>
                                <li>Test your code rigorously before submission</li>
                                <li>Document your changes when necessary</li>
                            </ol>
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwentytwo">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentytwo" aria-expanded="false" aria-controls="collapseTwentytwo">
                        22. What tools or technologies will I need?
                        </button>
                    </h2>
                    <div id="collapseTwentytwo" className="accordion-collapse collapse" aria-labelledby="headingTwentytwo" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            <ol type="i">
                                <li>Git for version control</li>
                                <li>A local development environment (IDE) appropriate for the programming language used in the project</li>
                                <li>Additional tools may depend on the specific project (e.g., Docker, testing frameworks)</li>
                            </ol>
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwentythree">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentythree" aria-expanded="false" aria-controls="collapseTwentythree">
                        23. Can I submit code without first creating a task?
                        </button>
                    </h2>
                    <div id="collapseTwentythree" className="accordion-collapse collapse" aria-labelledby="headingTwentythree" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            No, contributions must be aligned with existing tasks. Make sure to select an open task or get in touch with task creators if you have an idea for a new task.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwentyfour">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentyfour" aria-expanded="false" aria-controls="collapseTwentyfour">
                        24. How do I handle merge conflicts in my Pull Request (PR)?
                        </button>
                    </h2>
                    <div id="collapseTwentyfour" className="accordion-collapse collapse" aria-labelledby="headingTwentyfour" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            If there is a merge conflict when submitting your PR, you’ll need to:
                            <ol type="i">
                                <li>Pull the latest changes from the main branch into your feature branch</li>
                                <li>Resolve conflicts manually in your local repository</li>
                                <li>Commit the conflict resolution and push the updated branch</li>
                            </ol>
                            After doing this, the PR will update automatically.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwentyfive">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentyfive" aria-expanded="false" aria-controls="collapseTwentyfive">
                        25. How do I find projects or tasks that match my skills?
                        </button>
                    </h2>
                    <div id="collapseTwentyfive" className="accordion-collapse collapse" aria-labelledby="headingTwentyfive" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            On the OpenForge platform, you can browse open tasks and filter them by technology, difficulty level, or other categories. Look for tasks that align with your skill set or ones that offer an opportunity to learn new technologies.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwentyseven">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentyseven" aria-expanded="false" aria-controls="collapseTwentyseven">
                        26. What types of contributions are accepted (beyond coding)?
                        </button>
                    </h2>
                    <div id="collapseTwentyseven" className="accordion-collapse collapse" aria-labelledby="headingTwentyseven" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            In addition to code contributions, you can:
                            <ol type="i">
                                <li>Help with project documentation.</li>
                                <li>Suggest or implement tests.</li>
                                <li>Improve user interface (UI) design or enhance accessibility.</li>
                                <li>Report bugs or suggest new features.</li>
                            </ol>
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwentyeight">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentyeight" aria-expanded="false" aria-controls="collapseTwentyeight">
                        27.	How can I contribute to the testing process?
                        </button>
                    </h2>
                    <div id="collapseTwentyeight" className="accordion-collapse collapse" aria-labelledby="headingTwentyeight" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            There are multiple ways to assist with testing:
                            <ol type="i">
                                <li><b>Test Data Preparation:</b> Preparing realistic datasets for testing scenarios</li>
                                <li><b>Test Case Preparation:</b> Creating detailed test cases covering different aspects of the system</li>
                                <li><b>Manual Testing:</b> Testing the application manually for bugs, usability, and performance</li>
                                <li><b>Automated Testing:</b> Writing automated test scripts using tools like Selenium</li>
                                <li><b>Security Bug Testing:</b> Identifying vulnerabilities and conducting security testing</li>
                                <li><b>Performance Testing:</b> Testing the system under different loads to ensure it meets performance requirements</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
        </>
    )
}